import icon from 'vue-svgicon';

icon.register({
    'light/scooter-sport': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<circle pid="0" cx="20" cy="16" r="3.5" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round"/><circle pid="1" cx="3.5" cy="16.5" r="3" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round"/><path pid="2" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" d="M3.5 16.5l6.259-2.608M23.5 10.479S22.021 8 18.021 9.5M17.253 7a23.61 23.61 0 0 1-5.753.5c-3.435 0-6.932-1.053-9.8-1.41a1.066 1.066 0 0 0-.41 2.087A17.636 17.636 0 0 1 6.5 10.5c3 2 3 4.5 5.5 4.5h1c1.563 0 2.188-4.266 5.021-5.5"/><path pid="3" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" d="M15.079 7.342L14 9.5h-3L8.159 7.227M20 16L16.646 4.978A.676.676 0 0 0 16 4.5h-2.5"/>`,
    },
});
